var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  stroke: "currentColor",
  clipRule: "evenodd",
  viewBox: "0 0 12 12",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.188 5.938h.5V3.75a2.312 2.312 0 1 1 4.624 0V5.938H9c.449 0 .813.363.813.812v3a.813.813 0 0 1-.813.813H3a.813.813 0 0 1-.813-.813v-3c0-.449.364-.813.813-.813h.188Zm4.5 0h.5V3.75a2.188 2.188 0 0 0-4.376 0V5.938h3.875Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockFilled);
export default ForwardRef;